import { render, staticRenderFns } from "./MediaReviewPhotopointSessionOverview.vue?vue&type=template&id=f5e891c4&scoped=true&"
import script from "./MediaReviewPhotopointSessionOverview.vue?vue&type=script&lang=js&"
export * from "./MediaReviewPhotopointSessionOverview.vue?vue&type=script&lang=js&"
import style0 from "./MediaReviewPhotopointSessionOverview.vue?vue&type=style&index=0&id=f5e891c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e891c4",
  null
  
)

export default component.exports